import React from 'react';
import PropTypes from 'prop-types';
import DataSelect from '../DataSelect';

function UserSelect({
  name,
  onChange = null,
  onValueChange = null,
  onObjectChange = null,
  titleKey = 'name',
  value,
  noneTitle = null,
  params = {},
  url = '/resource/users',
}) {
  return (
    <DataSelect
      name={name}
      onChange={onChange}
      onValueChange={onValueChange}
      onObjectChange={onObjectChange}
      valueKey="id"
      titleKey={titleKey}
      value={value}
      noneTitle={noneTitle}
      params={params}
      url={url}
    />
  );
}

UserSelect.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  onObjectChange: PropTypes.func,
  titleKey: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  noneTitle: PropTypes.string,
  params: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  url: PropTypes.string,
};

UserSelect.defaultProps = {
  onChange: null,
  onValueChange: null,
  onObjectChange: null,
  titleKey: 'name',
  value: undefined,
  noneTitle: null,
  params: {},
  url: '/resource/users',
};

export default UserSelect;
